module.exports = __webpack_public_path__ + "media/21.ce879759.mp3";